import React, { useEffect, useState } from 'react'
import { css } from '@emotion/react'
import Input from 'front-end/src/components/common/form/input/Input'
import { Box, Flex } from 'front-end/src/components'
import Select from '../../../../../components/common/select/Select'
import {
  TemporalDirection,
  TimeDurationUnitsEnum
} from 'front-end/src/graphql/private/PrivateSchemaTypes'
import { plural, Trans } from '@lingui/macro'
import { feEnrolmentTimingsFilterEnum } from 'front-end/src/pages/manage-campaign-page/components/campaign-audience/CampaignAudienceHelpers'
import { useEditCampaignFilterContext } from 'front-end/src/pages/manage-campaign-page/components/campaign-audience/modals/enrolment-modal/EditCampaignFilterContext'

const getTimeDurationTranslations = (multiplier: number) => ({
  [TimeDurationUnitsEnum.WEEK]: plural(multiplier, {
    one: 'week',
    other: 'weeks'
  }),
  [TimeDurationUnitsEnum.DAY]: plural(multiplier, {
    one: 'day',
    other: 'days'
  }),
  [TimeDurationUnitsEnum.HOUR]: plural(multiplier, {
    one: 'hour',
    other: 'hours'
  }),
  [TimeDurationUnitsEnum.MONTH]: plural(multiplier, {
    one: 'month',
    other: 'months'
  }),
  [TimeDurationUnitsEnum.YEAR]: plural(multiplier, {
    one: 'year',
    other: 'years'
  })
})

const getTimeDurationSelectOpts = (multiplier: number) => {
  const labelTranslations = getTimeDurationTranslations(multiplier)

  return Object.entries(TimeDurationUnitsEnum).map(([value, label]) => ({
    value,
    label: labelTranslations[label]
  }))
}

export const EditCampaignFilterRelativeDate = ({
  setTemporalComparator,
  selectedEnrolmentTimingType,
  showAgoLabel = false
}: {
  setTemporalComparator: (type: any) => void
  selectedEnrolmentTimingType: feEnrolmentTimingsFilterEnum
  showAgoLabel?: boolean
}) => {
  const { editedFilter } = useEditCampaignFilterContext()
  const [multiplier, setMultiplier] = useState<number>(
    editedFilter.temporalComparator?.relative?.duration?.multiplier || 1
  )

  const [unit, setUnit] = useState<TimeDurationUnitsEnum>(
    editedFilter.temporalComparator?.relative?.duration?.unit ||
      TimeDurationUnitsEnum.WEEK
  )

  useEffect(() => {
    setTemporalComparator({
      relative: {
        ...editedFilter.temporalComparator?.relative,
        duration: {
          multiplier,
          unit
        },
        direction:
          selectedEnrolmentTimingType === feEnrolmentTimingsFilterEnum.MORE_THAN
            ? TemporalDirection.BEFORE
            : TemporalDirection.AFTER
      }
    })
  }, [multiplier, unit, selectedEnrolmentTimingType])

  const timeDurationSelectOpts = getTimeDurationSelectOpts(multiplier)

  return (
    <>
      <Input
        type="number"
        css={css`
          max-width: 50px;
          border-top-right-radius: 0;
          border-bottom-right-radius: 0;
        `}
        onChange={(val) => {
          setMultiplier(Number(val))
        }}
        min={1}
        value={multiplier}
      />
      <Flex marginLeft="1px" align="center">
        <Select
          options={timeDurationSelectOpts}
          value={timeDurationSelectOpts.find(({ value }) => {
            return value === unit
          })}
          css={css`
            .Select__control {
              min-width: 100px;
              border-top-left-radius: 0;
              border-bottom-left-radius: 0;
            }
          `}
          onChange={(option) => {
            setUnit(option?.value as TimeDurationUnitsEnum)
          }}
        />
        {showAgoLabel && (
          <Box ml="16px">
            <Trans>ago</Trans>
          </Box>
        )}
      </Flex>
    </>
  )
}
